import React, { memo } from "react";
import colors from "app/colors";
import { DrawIcon } from "modules/icons";
import CircularIconButton from "../_shared/buttons/circular-icon-button";
import { FileGalleryFragment, MessageThreadFragment } from "gql/graphql";
import {
  FILE_GALLERY_BUTTON_BOX_SIZE,
  FILE_GALLERY_BUTTON_BACKGROUND_COLOR,
  FILE_GALLERY_BUTTON_WIDTH,
} from "modules/utils/Constants";
import { VStack, Text } from "@chakra-ui/react";
import useEditImage from "modules/hooks/use-edit-image";
import {
  isImage,
  isMessageThreadReadOnlyAndIsReader,
} from "modules/utils/Functions";
import { useAuth } from "modules/providers/auth-provider";
import useRemovedFromThread from "modules/hooks/use-removed-from-thread";

interface IProps {
  messageThread?: MessageThreadFragment;
  draftId: string;
  file: FileGalleryFragment;
}

const FileGalleryEditImageButton = ({
  messageThread,
  file,
  draftId,
}: IProps) => {
  const { me } = useAuth();
  const { openEditImageModal } = useEditImage({
    file,
    draftId,
    isCloseAllModals: true,
  });
  const { isMeRemoved } = useRemovedFromThread(messageThread);

  if (!me) return null;

  if (!messageThread) return null;

  if (isMeRemoved || isMessageThreadReadOnlyAndIsReader(messageThread, me)) {
    return null;
  }

  return (
    <VStack spacing={1} w={FILE_GALLERY_BUTTON_WIDTH}>
      <CircularIconButton
        icon={
          <DrawIcon
            fill={colors.white}
            boxSize={FILE_GALLERY_BUTTON_BOX_SIZE}
          />
        }
        onClick={openEditImageModal}
        aria-label="draw"
        backgroundColor={FILE_GALLERY_BUTTON_BACKGROUND_COLOR}
        variant="hover"
        disabled={!isImage(file.contentType)}
      />
      <Text
        color={colors.grayPrimary}
        fontWeight={500}
        fontSize={10}
        opacity={!isImage(file.contentType) ? 0.5 : 1}
      >
        Draw
      </Text>
    </VStack>
  );
};

export default memo(FileGalleryEditImageButton);
